import ProjectService from "@/src/api/ProjectService.js";

export default {
  namespaced: true,

  state: {
    selectedProject: {},
    projects: [],
  },

  mutations: {
    SET_SELECTED_PROJECT(state, value) {
      state.selectedProject = value;
    },

    SET_PROJECTS(state, value) {
      state.projects = value;
    },
  },

  actions: {
    setSelectedProject({ commit }, value) {
      commit("SET_SELECTED_PROJECT", value);
    },

    setProjects({ commit }, value) {
      commit("SET_PROJECTS", value);
    },

    async fetchProjects({ commit }) {
      try {
        let allProjects = [];
        let page = 1;
        let hasMore = true;

        while (hasMore) {
          const response = await ProjectService.tasks.fetchProjects({ page });
          if (!response?.success) {
            return { success: false, error: response?.error };
          }
          const projects = response?.data?.projects || [];
          allProjects = allProjects.concat(projects);
          hasMore = response?.data?.has_more === true;
          page++;
        }

        commit("SET_PROJECTS", allProjects);
        return { success: true, projects: allProjects };
      } catch (error) {
        console.error("An error occurred while fetching projects: ", error);
        return { success: false, error: error.message };
      }
    },
  },

  getters: {
    selectedProject: (state) => state.selectedProject,
    selectedProjectID: (state) => state.selectedProject?.id,
    projects: (state) => state.projects,
  },
};